import { useCallback } from 'react'

import { useImportDependency } from 'core-components/hooks/useImportDependency'
import { wsConnectionPool } from 'src/core/classes/ws/WSConnectionPool'
import { AppLoader } from 'src/core/components/app/AppLoader'
import { CoreLoaderWrapper, ILoader } from 'src/core/components/app/loaders'

const importWrappersModuleFederation = {
  kbase: {
    key: 'remoteKbase/KBaseLoaderWrapper',
    importFn: () => import('remoteKbase/KBaseLoaderWrapper'),
  },
  docflow: {
    key: 'remoteDocflow/DebuggerLoaderWrapper',
    importFn: () => import('remoteDocflow/DebuggerLoaderWrapper'),
  },
}

export const AppLoaderWrapper = ({ children, ...props }: ILoader) => {
  const { isDependencyLoading: isKbaseWrapperLoading, Module: KbaseModuleWrapper } =
    useImportDependency({
      key: importWrappersModuleFederation.kbase.key,
      importFunction: importWrappersModuleFederation.kbase.importFn,
      defaultValue: ({ children }) => children,
    })

  const { isDependencyLoading: isDocflowWrapperLoading, Module: DocflowModuleWrapper } =
    useImportDependency({
      key: importWrappersModuleFederation.docflow.key,
      importFunction: importWrappersModuleFederation.docflow.importFn,
      defaultValue: ({ children }) => children,
    })

  const beforeInitCallback = useCallback(() => {
    wsConnectionPool.initWSPool(import.meta.env.VITE_WS_SERVERS)
  }, [])

  const isWrappersLoading = isKbaseWrapperLoading || isDocflowWrapperLoading

  if (isWrappersLoading) {
    return <AppLoader />
  }

  return (
    <CoreLoaderWrapper {...props} beforeInitCallback={beforeInitCallback}>
      <KbaseModuleWrapper>
        <DocflowModuleWrapper>{children}</DocflowModuleWrapper>
      </KbaseModuleWrapper>
    </CoreLoaderWrapper>
  )
}
